var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_0_1348",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.07129C7.75212 4.07129 4.71387 7.10955 4.71387 10.8574V18.3222V19.0008V28.3919C4.71387 29.53 6.03028 30.1627 6.91895 29.4517L10.7565 26.3817C11.2378 25.9967 11.8358 25.7869 12.4522 25.7869H25.0722C28.8201 25.7869 31.8584 22.7486 31.8584 19.0008V10.8574C31.8584 7.10954 28.8201 4.07129 25.0723 4.07129H11.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 4.07129C7.75212 4.07129 4.71387 7.10955 4.71387 10.8574V18.3222V19.0008V28.3919C4.71387 29.53 6.03028 30.1627 6.91895 29.4517L10.7565 26.3817C11.2378 25.9967 11.8358 25.7869 12.4522 25.7869H25.0722C28.8201 25.7869 31.8584 22.7486 31.8584 19.0008V10.8574C31.8584 7.10954 28.8201 4.07129 25.0723 4.07129H11.5Z",
    fill: "#2D3D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91895 29.4517L7.13091 29.7167L6.91895 29.4517ZM5.05317 10.8574C5.05317 7.29694 7.93951 4.4106 11.5 4.4106V3.73198C7.56473 3.73198 4.37456 6.92216 4.37456 10.8574H5.05317ZM5.05317 18.3222V10.8574H4.37456V18.3222H5.05317ZM5.05317 19.0008V18.3222H4.37456V19.0008H5.05317ZM5.05317 28.3919V19.0008H4.37456V28.3919H5.05317ZM6.70698 29.1868C6.04049 29.72 5.05317 29.2455 5.05317 28.3919H4.37456C4.37456 29.8145 6.02008 30.6054 7.13091 29.7167L6.70698 29.1868ZM10.5445 26.1168L6.70698 29.1868L7.13091 29.7167L10.9684 26.6467L10.5445 26.1168ZM25.0722 25.4476H12.4522V26.1262H25.0722V25.4476ZM31.5191 19.0008C31.5191 22.5612 28.6327 25.4476 25.0722 25.4476V26.1262C29.0075 26.1262 32.1977 22.936 32.1977 19.0008H31.5191ZM31.5191 10.8574V19.0008H32.1977V10.8574H31.5191ZM25.0723 4.4106C28.6327 4.4106 31.5191 7.29694 31.5191 10.8574H32.1977C32.1977 6.92215 29.0075 3.73198 25.0723 3.73198V4.4106ZM11.5 4.4106H25.0723V3.73198H11.5V4.4106ZM10.9684 26.6467C11.3896 26.3098 11.9128 26.1262 12.4522 26.1262V25.4476C11.7587 25.4476 11.086 25.6836 10.5445 26.1168L10.9684 26.6467Z",
    fill: "url(#paint0_linear_0_1348)",
    fillOpacity: 0.7,
    mask: "url(#path-1-inside-1_0_1348)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5676,
    cy: 14.9963,
    r: 1.69653,
    fill: "#0088CC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.3538,
    cy: 14.9963,
    r: 1.69653,
    fill: "#0088CC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.1399,
    cy: 14.9963,
    r: 1.69653,
    fill: "#0088CC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_0_1348",
    x: 0.713867,
    y: 0.0712891,
    width: 35.1445,
    height: 33.6802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1348"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_0_1348",
    result: "effect2_dropShadow_0_1348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1348",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_0_1348"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1348",
    x: 7.87109,
    y: 11.2998,
    width: 20.9648,
    height: 7.39307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.231373 0 0 0 0 0.407843 0 0 0 0 1 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1348",
    x1: 5.39248,
    y1: 7.92335,
    x2: 28.02,
    y2: 28.4241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.44
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatActive);
export default __webpack_public_path__ + "static/media/chat-active.03dc4a3f34699a43092751e390130886.svg";
export { ForwardRef as ReactComponent };